// ./stores/memos.js
import {create} from 'zustand'
interface AccountState {
  accessToken: String
  setAccessToken: (token:String) => void
}

const useAccountStore = create<AccountState>((set) => ({
  accessToken: "",
  setAccessToken: (token:String) => set({ accessToken: token })
}))

export default useAccountStore